import { useTranslation } from 'react-i18next';
import { prepareDoctorName, DateFormatter } from 'infrastructure/functions';
import { convertSecondsToTime } from 'utils/timeHelper';
import { DateFormats } from 'infrastructure/enums';

import s from './styles.module.scss';

import type {
  IChartSessionLog,
  IChartSessionLogUser,
} from 'infrastructure/interfaces/i-session-log';
import type { IBaseTableColumns } from 'components/atoms/base-table/types';

export const logsColumns = (): IBaseTableColumns<IChartSessionLog> => {
  const { t } = useTranslation();

  return [
    {
      label: t('labels.user'),
      key: 'user',
      width: '270px',
      render(value: IChartSessionLogUser) {
        const userName = prepareDoctorName(value);
        return (
          <span className={s.date} data-cy="session-logs-user">
            {userName}
          </span>
        );
      },
    },
    {
      label: t('labels.sessionStart'),
      key: 'sessionStart',
      width: '120px',
      render(value: string) {
        const date = DateFormatter({
          date: value,
          format: DateFormats['MM-dd-yy | h:mm:ss a'],
        });
        return (
          <span className={s.date} data-cy="session-logs-session-start">
            {date}
          </span>
        );
      },
    },
    {
      label: t('labels.sessionEnd'),
      key: 'sessionEnd',
      width: '120px',
      responsive: ['md'],
      render(value: string | null) {
        const date = value
          ? DateFormatter({
              date: value,
              format: DateFormats['MM-dd-yy | h:mm:ss a'],
            })
          : t('labels.bannerNoData');

        return (
          <span className={s.date} data-cy="session-logs-session-end">
            {date}
          </span>
        );
      },
    },
    {
      label: t('labels.chartTime'),
      align: 'right',
      key: 'duration',
      width: '100px',
      render(value: number) {
        return (
          <span className={s.date} data-cy="session-logs-chart-time">
            {convertSecondsToTime(value)}
          </span>
        );
      },
    },
    {
      label: t('labels.rpmBilledTime'),
      align: 'right',
      key: 'rpmTime',
      width: '100px',
      render(value: number) {
        return (
          <span className={s.date} data-cy="session-logs-rpm-time">
            {convertSecondsToTime(value)}
          </span>
        );
      },
    },
    {
      label: t('labels.ccmBilledTime'),
      align: 'right',
      key: 'ccmTime',
      width: '100px',
      render(value: number) {
        return (
          <span className={s.date} data-cy="session-logs-ccm-time">
            {convertSecondsToTime(value)}
          </span>
        );
      },
    },
  ];
};
